export const adaptContratoRIEV = (contratoData) => {    
    return {
        id: contratoData?.idEvaluacion,
        displayName: contratoData?.contrato,
        name: contratoData?.contrato
    }
}

export const adaptContratoRIEVArray = (
    contratos
) => {
    return structuredClone(contratos?.contratosRIEV.valorEsperado)
        ?.map(contrato => adaptContratoRIEV(contrato));
}